import { Breadcrumbs, Button, CircularProgress, Container, FormControl, Grid, Link, makeStyles, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import AddIcon from '@material-ui/icons/Add';
import CachedIcon from '@material-ui/icons/Cached';
import moment from "moment";
import clsx from 'clsx';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import SelectFilter from '../models/SelectFilter';
import DeliverablesScreen from '../DeliverablesScreen';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { ALL_PROJECTS_TABLE, PROJECT_DELIVERABLES_TABLE } from '../../../../containers/actions/types';
import { fetchProjectDeliverables } from '../../../../containers/actions/common/projectActions';
import PaginationInput from '../../models/pagination/PaginationInput';
import HomeIcon from "@material-ui/icons/Home"; 
import { presentFormatedData } from '../../functionalComponents/dataFormatFunctions';
import CMOFilter from '../models/CMOFilter';
import { cmoMembersList } from '../../../../containers/actions/pharmaCo/purchaseOrderActions';

const useStyles = makeStyles((theme) => ({
    backText: {
      // display: 'flex',
      // alignItems: 'center',
      cursor: 'pointer',
    fontWeight: 500,
    paddingBottom: '1rem',
      paddingRight:'1rem',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    icon: {
      paddingLeft: '1rem',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
        fontSize: '1.7rem',
      },
    },

    backGrid: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
    title: {
      fontWeight: 500,
      textAlign: 'left',
      [theme.breakpoints.down('xs')]: {
        fontSize: '0.875rem',
      },
    },
    children: {
      paddingTop: '1rem',
    },
    button: {
      textTransform: 'none',
      '&:hover': {
        background: 'transparent',
        borderBottom: '2px solid black',
      },
    },
    upload: {
        background:
          'transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;',
        color: 'white',
        textTransform: 'none',
        borderRadius: '2rem',
        // marginRight: 20,
        padding: '5px 20px',
        '&:hover': {
          backgroundColor: 'green',
          background: 'green',
          color: 'white',
        },
    },
    refreshContainerSty:{display: 'flex', justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
          justifyContent: 'flex-start',
          paddingTop: '1rem',
        },
        [theme.breakpoints.down('xs')]: {
          paddingTop: '1rem',
        },
      },
      refreshSty:{display: 'flex',alignItems: 'center',cursor: 'pointer','&:hover': {
        textDecoration: 'underline',
      }},
      padR20: {
        paddingRight: 20,
        [theme.breakpoints.down('xs')]: {
          paddingRight: 0,
        },
      },
      hgText: {
        fontWeight: 500,
        paddingRight: theme.spacing(1),
      },
      outlined: {
        padding: theme.spacing(1),
      },
      formControl: {
        minWidth: 120,
        fontSize: '0.875rem',
      },
      formPerPage: {
        minWidth: 60,
        fontSize: '0.875rem',
  },
  multipleLogo: {
    border: '1px solid #7d7c7c',
    borderRadius: '4px',
    padding: '0.3rem',
    height: 'inherit',
    marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
      border: '1px solid #FFF',
    },
  },
  clickableTextSty: {
    maxWidth:'250px',
    '&:hover': {
      textDecoration: 'underline',
    color: '#2196F3',
    cursor: 'pointer'
    },
  }
}));


const formatData = (data) => {
  const groupedData = {};

  data.forEach((item) => {
    const { cdmoOrgName, deliverableTypeName, cdmoDepartmentName, sponsorOrgName, sponsorDepartmentName } = item;

    const key = item?.collabrixBatchID ? `${cdmoOrgName}-${deliverableTypeName}-${cdmoDepartmentName}-${item.collabrixBatchID}`: `${cdmoOrgName}-${deliverableTypeName}-${cdmoDepartmentName}`;

    if (!groupedData[key]) {
      groupedData[key] = {
        cdmoOrgName,
        deliverableTypeName,
        cdmoDepartmentName,
        sponsorOrgName,
        sponsorDepartmentName,
        deliverables: [],
      };
    }

    // Push the deliverable in the required format
    groupedData[key].deliverables.push({
      ...item,
      deliverableDescription: [item.deliverableDescription],
      sponsorPOCIDName: item.sponsorPOCIDName,
      cdmoPOCIDName: item.cdmoPOCIDName,
      deliverableStatus: item.deliverableStatus,
    });
  });

  // Convert groupedData object back to an array
  return Object.values(groupedData);
};


const renderStatusButton = (deliverableStatus) => {
    let color;
    switch (deliverableStatus) {
      case 'Ongoing':
        color = '#FFA500'; // Bright orange for Ongoing
        break;
      case 'Completed':
        color = '#4CAF50'; // Green for Completed
        break;
      case 'Awaiting Start':
        color = '#A9A9A9'; // Grey for Awaiting Start
        break;
      default:
        color = '#000';
    }
    return (
        <Typography variant='body1' style={{textAlign: 'center',
            padding: '0.25rem',
            borderRadius: '0.45rem',
            fontSize: '0.875rem',color: 'white',
            backgroundColor: color,
        border: `2px solid ${color}`,
      whiteSpace:'nowrap'}}>
            {deliverableStatus}
          </Typography>
    );
  };
  
const ProjectDeliverables = (props) => {
    const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch()
  let loading = true;
  const { collabType, organizationName } = localStorage;
  const [CMOMember, selectCMO] = useState(
    collabType === 'Pharma Co' ? 0 : location.state.project.cdmoOrgID
  );
  //console.log(location.state.project.cdmoOrgID)
  const [noRowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('')
  const [selectedDeliverable, setSelected] = useState(location.state.project)

  useEffect(() => {
    // Fetch projects from API
    loading = true;
    dispatch({
      type: PROJECT_DELIVERABLES_TABLE,
      payload: undefined
    })
    let data = {
      collabrixProjectID: location.state.project.collabrixProjectID,
      sponsorOrgID: location.state.project.sponsorOrgID,
      cdmoOrgID: CMOMember
    }
    dispatch(fetchProjectDeliverables(data));
    dispatch(
      cmoMembersList({
          collabType: localStorage.collabType,
          roleName: localStorage.roleName,
          organizationName: localStorage.organizationName,
          ecosystemId: localStorage.ecosystemId
        // collabType: 'Pharma Co',
        // roleName: 'Admin',
        // organizationName: 'Lupin',
        // ecosystemId: 1,
      })
    );
  }, [dispatch,CMOMember]);

  const handleRefresh = () => {
    loading = true;
    dispatch({
      type: PROJECT_DELIVERABLES_TABLE,
      payload: undefined
    })
    setError('')
    loading = true;
    let data = {
      collabrixProjectID: location.state.project.collabrixProjectID,
      sponsorOrgID:location.state.project.sponsorOrgID,
      cdmoOrgID: CMOMember
    }
    dispatch(fetchProjectDeliverables(data));
  }

  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );

    const handleSetRows = (event) => {
        setRowsPerPage(event.target.value);
    };

  const handleBack = () => {
    dispatch({
      type: PROJECT_DELIVERABLES_TABLE,
      payload: undefined
    })
    dispatch({
      type: ALL_PROJECTS_TABLE,
      payload: undefined
    })
        history.push(
            `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/projectsdashboard`
        );
  }
  
    // function for CMO Fliter
    const handleSelectCMO = (event) => {
      event.preventDefault();
      let val = event.target.value;
      if (val === 0) {
        selectCMO(0);
      } else {
        // let cmo = cmoMemberWithId.filter(
        //   (member) => member.organizationName === val
        // );
        selectCMO(val);
      }
      setCurrentPage(1);
      loading = true;
  };

  const selectedCMO = () => {
    if (CMOMember === 0) {
      return CMOMember;
    } else {
      let cmo = cmoMemberWithId.filter(
        (member) => member.organizationId === parseInt(CMOMember)
      );
      return cmo[0].organizationId;
    }
  };
  
  const openDescriptionOfDeliverables = (row) => {
    setSelected({...selectedDeliverable,...row})
    setOpen(true);
  };

  const closeDescriptionOfDeliverables = () => {
    setOpen(false);
  };

  const rows = useSelector((state) => {
    if (state.pcmp.common.Projects.projectDeliverables?.status === true) {
      if (loading) {
        loading = false
      }
      return state.pcmp.common.Projects.projectDeliverables?.data
    } else if (state.pcmp.common.Projects.projectDeliverables?.status === false) {
      if (loading) {
        loading = false
      }
      if (error === '') {
        setError('Something went wrong. Please try again later.')
        }
        return []
    } else {
      return [];
    }
  });

  const projectTable = rows;

  let totalPages = Math.ceil(projectTable.length / noRowsPerPage);

  let records = currentPage * noRowsPerPage;

  const projectTableData = projectTable
  ? formatData(projectTable.slice(records - noRowsPerPage, records))
  : []

  const handlePageChange = (data) => {
    setCurrentPage(data);
  };
  return (
      <React.Fragment>
          <Grid container justifyContent='space-between'>
        <Grid container item sx={12} md={6} >
          <Grid item>
              <div style={{ display: 'flex' }} className={classes.button}>
                <ArrowBackIosIcon
                  fontSize='small'
                  className={classes.icon}
                  onClick={handleBack}
                />
                <Typography
                  variant='body2'
                  className={classes.backText}
                  onClick={handleBack}
                >
                  Back{' '}
            </Typography>
            </div>
            </Grid>
          <Grid item>
          <Breadcrumbs
          separator={'/'}
          aria-label="breadcrumb"
          style={{ margin: "0px 2rem", color:'#2196f3' }}
        >
          {/* Home link with an icon */}
          <Link
                color="secondary"
                onClick={handleBack}
            style={{ display: "flex", alignItems: "center", cursor:'pointer' }}
          >
            <HomeIcon fontSize="small" style={{ marginRight: "4px" }} />
          </Link>

          {/* Project Dashboard link */}
          <Link
                color="secondary"
                style={{cursor:'pointer' }}
                onClick={handleBack}
          >
            Project Dashboard
          </Link>

          {/* Project Name link */}
          <Link
            //   href={`/project/${projectData.projectName}`}
                color="secondary"
                style={{cursor:'pointer' }}
          >
            Compound ID - {location.state.project.projectName}
          </Link>
        </Breadcrumbs>
            </Grid>
             
        </Grid>
              <Grid item>
              <Button
              startIcon={<AddIcon />}
              // onClick={() => {
              //   setOpenUploadDSBatch(true);
              // }}
              className={classes.upload}
            >
              Add New Entry
            </Button>
              </Grid>
              
          </Grid>
          <Grid container alignItems='center' style={{ paddingBottom: '0.5rem', paddingTop: '1rem' }} >
              <Grid item xs={12} sm={10} md={6}>
                  <Grid container spacing={5}>
                      <Grid item xs={4}>
                      <Typography variant='body2' style={{fontWeight: 500, marginBottom:'10px'}}>
                            View by Deliverable Type:
                          </Typography>
                          <SelectFilter disabled={true} value={'all'} objectArray={[]} />
                      </Grid>
            {localStorage.collabType !== 'CMO' && <Grid item xs={4}>
              <Typography variant='body2' style={{ fontWeight: 500, marginBottom: '10px' }}>
                View by CMO:
              </Typography>
              {/* <SelectFilter value={'all'}  objectArray={[]} /> */}
              <CMOFilter handleSelectCMO={handleSelectCMO} CMOMember={collabType === 'Pharma Co' && selectedCMO()} />
            </Grid>}
                      <Grid item xs={4}>
                      <Typography variant='body2' style={{fontWeight: 500, marginBottom:'10px'}}>
                            View by Departments:
                          </Typography>
                          <SelectFilter disabled={true} value={'all'}  objectArray={[]} />
                      </Grid>
                  </Grid>
        
          
          </Grid>
        <Grid item xs={12} md={6} style={{alignSelf:'self-end'}}>
          <Grid
            container
            className={classes.refreshContainerSty}
          >
            <Typography variant='caption' className={clsx(classes.padR20)}>
              {`Last synced @ ${moment(new Date()).format(
                'HH:mm:ss; DD MMMM, YYYY'
              )}`}
            </Typography>

            <Typography
              variant='caption'
              color='primary'
              className={classes.refreshSty}
              onClick = {handleRefresh}
            >
              Refresh
              <CachedIcon color='primary' style={{ fontSize: 15 }} />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container alignItems='center' justifyContent="flex-end" >
        <Grid item>
        <Typography variant='body2' className={classes.hgText}>
        PER PAGE
      </Typography>
      <FormControl className={classes.formPerPage}>
        <Select
          labelId='perpage-filter'
          id='perpage-filter-id'
          value={noRowsPerPage}
          variant='outlined'
          onChange={handleSetRows}
          classes={{
            outlined: classes.outlined,
          }}
        >
          <MenuItem value={3}>3</MenuItem>
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={15}>15</MenuItem>
          <MenuItem value={30}>30</MenuItem>
        </Select>
      </FormControl>
        </Grid>
          </Grid>
      <TableContainer component={Paper} style={{ marginTop: 20,maxHeight: 500 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow style={{ backgroundColor: "#F9F9FC" }}>
              {localStorage.collabType !== 'CMO' && <TableCell align='left'>CMO</TableCell>} 
              <TableCell align='left' style={{whiteSpace:'nowrap'}}>Deliverable Type</TableCell>
              <TableCell align='left'>Departments</TableCell>
              <TableCell align='left'>Description of Deliverables</TableCell>
              <TableCell align="left" style={{whiteSpace:'nowrap'}}>Scheduled Delivery Date</TableCell>
              <TableCell align='left'>BMS Point of Contact</TableCell>
              <TableCell align='left'>CMO Point of Contact</TableCell>
              <TableCell align='center'>Status</TableCell>
              <TableCell align='center'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loading === true && (
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={9}>
                      <div style={{ textAlign: 'center' }}>
                        <CircularProgress color='primary'  />
                      </div>
                    </TableCell>
                  </TableRow>
                )}
            {loading === false && error ==='' && (projectTableData.length > 0 ? projectTableData.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <TableRow>
                  {localStorage.collabType !== 'CMO' && <TableCell align='left' style={{ borderBottom: row.deliverables.length > 1 && 'none' }}>
                    {presentFormatedData(row.cdmoOrgName)}
                  </TableCell>}
                  <TableCell align='left'  style={{borderBottom: row.deliverables.length > 1 &&'none'}}>
                    {presentFormatedData(row.deliverableTypeName)}
                  </TableCell>
                  <TableCell align='left'  style={{borderBottom: row.deliverables.length > 1 &&'none'}}>
                    {localStorage.collabType === 'CMO' ? presentFormatedData(row.cdmoDepartmentName): presentFormatedData(row.sponsorDepartmentName)}
                  </TableCell>
                  <TableCell align='left'>
                    {row.deliverables[0].deliverableDescription.map((desc, i) => (
                          <div
                          key={i}
                            onClick={()=>openDescriptionOfDeliverables(row.deliverables[0])}
                            // style={{ textDecoration: 'underline', color: '#3f51b5', cursor:'pointer' }}
                            className={classes.clickableTextSty}
                          >
                            {presentFormatedData(desc)}
                          </div>
                    ))}
                  </TableCell>
                  <TableCell align="left" style={{whiteSpace:'nowrap'}}>{row.deliverables[0].deliveryDate ? moment(row.deliverables[0].deliveryDate).format('DD-MMM-YYYY'):' - '}</TableCell> 
                  <TableCell align='left'>{presentFormatedData(row.deliverables[0].sponsorPOCIDName)}</TableCell>
                  <TableCell align='left'>{presentFormatedData(row.deliverables[0].cdmoPOCIDName)}</TableCell>
                  <TableCell align='center'>{renderStatusButton(row.deliverables[0].deliverableStatus)}</TableCell>
                  <TableCell align="center"><EditIcon
        fontSize='small'
        className={classes.multipleLogo}
      /></TableCell>
                </TableRow>
                {row.deliverables.slice(1).map((deliverable, index) => (
                  <TableRow key={index}>
                    {localStorage.collabType !== 'CMO' && <TableCell align='left' style={{ borderBottom: row.deliverables.length > index + 2 && 'none' }}></TableCell>}
                    <TableCell align='left' style={{borderBottom: row.deliverables.length > index + 2  &&'none'}}></TableCell>
                    <TableCell align='left' style={{borderBottom: row.deliverables.length > index + 2  &&'none'}}></TableCell>
                    <TableCell align='left'>
                      {deliverable.deliverableDescription.map((desc, i) => (
                        <div
                        key={i}
                          onClick={()=>openDescriptionOfDeliverables(deliverable)}
                          // style={{ textDecoration: 'underline', color: '#3f51b5', cursor:'pointer' }}
                          className={classes.clickableTextSty}
                        >
                          {desc}
                        </div>
                      ))}
                    </TableCell>
                    <TableCell align="left" style={{whiteSpace:'nowrap'}}>{deliverable.deliveryDate ? moment(deliverable.deliveryDate).format('DD-MMM-YYYY'):' - '}</TableCell> 
                    <TableCell align='left'>{presentFormatedData(deliverable.sponsorPOCIDName)}</TableCell>
                    <TableCell align='left'>{presentFormatedData(deliverable.cdmoPOCIDName)}</TableCell>
                    <TableCell align='center'>{renderStatusButton(deliverable.deliverableStatus)}</TableCell>
                    <TableCell align="center"><EditIcon
        fontSize='small'
        className={classes.multipleLogo}
      /></TableCell>
                  </TableRow>
                ))}
              </React.Fragment>
            )): <TableRow>
            <TableCell
              colSpan={9}
              align='center'
            >
              No Records Found
            </TableCell>
            </TableRow>)}
            {loading === false && error !=='' && (<TableRow style={{border: '2px solid #FF0000',
                backgroundColor: '#FFF0F0',}}><TableCell
              colSpan={9}
              align='center'
              
            >
              Something went wrong. Please try again later.
            </TableCell>
            </TableRow>)}
          </TableBody>
        </Table>
      </TableContainer>
      <Grid>
      <PaginationInput
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          page={currentPage}
        />

      {open && (
        <DeliverablesScreen
          openDialog={open}
            handleBackClick={closeDescriptionOfDeliverables}
            projectData={{ ...selectedDeliverable }}
            deliverablesData = {{ ...selectedDeliverable }}
        />
        )}
        </Grid>
    </React.Fragment>
  )
}

export default ProjectDeliverables